import { createSlice } from '@reduxjs/toolkit';

const SESSION_KEY = 'medical_questionnaire_total_sections_v1';

function readSessionTotalSections() {
  if (typeof window === 'undefined') return 0;
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return 0;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
  } catch {
    return 0;
  }
}

function persistTotalSections(totalSections) {
  if (typeof window === 'undefined') return;
  try {
    if (!totalSections) {
      sessionStorage.removeItem(SESSION_KEY);
      return;
    }
    sessionStorage.setItem(SESSION_KEY, String(totalSections));
  } catch {
    // ignore
  }
}

const medicalQuestionnaireProgressSlice = createSlice({
  name: 'medicalQuestionnaireProgress',
  initialState: {
    totalSections: readSessionTotalSections(),
    /** Live UI while answering; cleared when leaving the questionnaire flow. */
    optimisticCompletionPercentage: null,
    optimisticFilledSections: 0,
  },
  reducers: {
    setMedicalQuestionnaireTotalSections(state, action) {
      const n = Math.max(0, Number(action.payload) || 0);
      state.totalSections = n;
      persistTotalSections(n);
    },
    setOptimisticQuestionnaireProgress(state, action) {
      const {
        optimisticCompletionPercentage = null,
        optimisticFilledSections = 0,
        totalSections,
      } = action.payload || {};
      if (totalSections != null) {
        const n = Math.max(0, Number(totalSections) || 0);
        state.totalSections = n;
        persistTotalSections(n);
      }
      if (optimisticCompletionPercentage == null) {
        state.optimisticCompletionPercentage = null;
        state.optimisticFilledSections = 0;
        return;
      }
      state.optimisticCompletionPercentage = Math.min(
        100,
        Math.max(0, Math.round(Number(optimisticCompletionPercentage) || 0))
      );
      if (optimisticFilledSections != null && optimisticFilledSections !== undefined) {
        state.optimisticFilledSections = Math.max(0, Number(optimisticFilledSections) || 0);
      }
    },
    clearOptimisticQuestionnaireProgress(state) {
      state.optimisticCompletionPercentage = null;
      state.optimisticFilledSections = 0;
    },
    resetMedicalQuestionnaireProgress() {
      persistTotalSections(0);
      return {
        totalSections: 0,
        optimisticCompletionPercentage: null,
        optimisticFilledSections: 0,
      };
    },
  },
});

export const {
  setMedicalQuestionnaireTotalSections,
  setOptimisticQuestionnaireProgress,
  clearOptimisticQuestionnaireProgress,
  resetMedicalQuestionnaireProgress,
} = medicalQuestionnaireProgressSlice.actions;
export default medicalQuestionnaireProgressSlice.reducer;
